import { getEnvRequired } from '../../shared/utilities/env';

import { DossierId } from '../dossier/types';
import { ApiClient } from '../shared/api/client';

import { serializeInTripReviewsFromAPI } from './serializers';
import { InTripReviewsJSONAPIResponse } from './types';

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(true);

export async function fetchInTripReviews() {
    const url = `${REQUEST_MANAGER_API_URL}/in-trip-review/list`;

    const response = await apiClient.get<InTripReviewsJSONAPIResponse>(url);
    return serializeInTripReviewsFromAPI(response);
}

export async function patchRemoveInTripReview(dossierId: DossierId) {
    const url = `${REQUEST_MANAGER_API_URL}/in-trip-review/acknowledge/${dossierId}`;
    await apiClient.patch(url);
}
